import React from 'react';
import { ISnackContext } from './types';

// consider the right state to show
// not every state & action in the context will be consume

export default React.createContext<ISnackContext>({} as ISnackContext);
